import React from "react";
import { CheckCircle2 } from "lucide-react";

const DifferenceBlock = ({ index, title, body, reverse }) => {
  return (
    <div className={`flex flex-col md:flex-row ${reverse ? "md:flex-row-reverse" : ""} items-start gap-6 py-8 border-b border-gray-100 last:border-0`}>
      <div className="flex items-center gap-4 md:w-1/3">
        <span className="font-heading font-extrabold text-3xl text-p3-gold/70">{String(index).padStart(2, "0")}</span>
        <div className="w-9 h-9 rounded-full bg-p3-navy/5 flex items-center justify-center shrink-0">
          <CheckCircle2 size={18} className="text-p3-blue" />
        </div>
      </div>
      <div className="md:w-2/3">
        <h3 className="font-heading font-bold text-xl text-p3-navy mb-2">{title}</h3>
        <p className="text-sm text-p3-muted leading-relaxed">{body}</p>
      </div>
    </div>
  );
};

export default DifferenceBlock;
